<div *ngIf="visible" id="body-vto-app" class="hide body-vto-app">
  <div id="app-container" class="detail">
    <div id="title-text">Pruébalo en vivo</div>
    <div id="orig-canvas-container" class="canvas-container"></div>
    <div id="rendered-canvas-container" class="canvas-container"></div>
    <div id="ui-interface">
      <div id="compare-slider" ontouchstart="touchSlide(event)" onmousedown="mouseSlide(event)">
        <img id="compare-drag" draggable="false" alt="compare-drag">
      </div>
      <div class="makeup-type-container">
        <div id="lipcolor-box" class="selection-box gray-hover" onclick="selectMakeupCategory('lipcolor')">Colores
          Disponibles</div>
      </div>
      <div class="swatch-background">
        <ul #swatchContainer id="lipcolor-swatch-container" class="swatch-container"></ul>
      </div>
      <div id="cta-container">
        <img id="adjust-collapse-cta" alt="adjust-collapse-cta" class="cta-button moveable-button"
          onclick="collapseAllAdjustButtons()">
        <img id="adjust-left-eye-cta" alt="adjust-left-eye-cta" class="cta-button moveable-button"
          onclick="adjustFeature('leftExtendedEye2D')">
        <img id="adjust-right-eye-cta" alt="adjust-right-eye-cta" class="cta-button moveable-button"
          onclick="adjustFeature('rightExtendedEye2D')">
        <img id="adjust-lips-cta" alt="adjust-lips-cta" class="cta-button moveable-button"
          onclick="adjustFeature('extendedOuterMouth2D')">
        <img id="adjust-cta" alt="adjust-cta" class="cta-button" onclick="expandAllAdjustButtons()">
        <img id="before-after-cta" alt="before-after-cta" class="cta-button" onclick="toggleBeforeAfter()">
      </div>
      <img id="close-button" onclick="stopMakeupApp()" (click)="stop()" alt="close-button">
    </div>
    <div id="adjust-container"></div>
    <div id="instruction-panel">
      <div id="instruction-text">Adjust the dots to outline your <span id="feature-text">lips</span></div>
      <img id="left-adjust-image" alt="left-adjust-image" class="adjust-image">
      <img id="right-adjust-image" alt="right-adjust-image" class="adjust-image">
      <div id="mouth-open-chk">
        <div id="toggle-mouth" onclick="toggleMouth()" class="checkbox">
          <img id="checkmark" alt="checkmark">
        </div>
        <span id="mouth-open-text">Mouth is open</span>
      </div>
    </div>
    <div onclick="saveCoords()" id="save-coords" class="save-cancel">SAVE DOTS</div>
    <div onclick="disableAdjustButtons()" id="adjust-cancel">
      <span id="cancel-text">Cancel</span>
    </div>
    <div onclick="revertToOriginal()" id="adjust-reset" class="save-cancel">RESET DOTS</div>
    <img id="gif-loader" alt="gif-loader">
    <div id="loading-overlay"></div>
    <div id="error-screen">
      <div id="error-title">Algo salió mal.</div>
      <div id="error-text">Por favor, brinde los permisos necesarios para acceder a su cámara.</div>
      <div id="try-again-button" onclick="closeErrorScreen()">OK</div>
    </div>
  </div>
</div>